import { Heading, Loader, Row } from '@amzn/meridian';
import { JAlerts } from 'components/JAlerts/JAlerts';
import { useTpPageTopBarQuery } from 'generated/graphql';
import { stylesheet } from 'typestyle';
import { TabNavigation } from './TabNavigation';
import { TPActionMenu } from './TPActionMenu';
import { TPShareButton } from './TPShareButton/TPShareButton';

const css = stylesheet({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  navigationContainer: {
    alignItems: 'flex-start',
    display: 'flex',
    padding: '0px 0px 24px',
  },
  topContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px 0px 16px',
  },
});

type TPPageTopBarProps = {
  projectId: string;
};

export const TPPageTopBar = ({ projectId }: TPPageTopBarProps) => {
  const { loading, data } = useTpPageTopBarQuery({
    variables: {
      id: projectId,
    },
  });

  return (
    <div className={css.container}>
      <div className={css.topContainer}>
        <Heading level={1} type="h400">
          {loading && <Loader size="small" type="linear" />}
          {!loading && data?.trafficProject.name}
        </Heading>
        <Row>
          <TPActionMenu />
          <TPShareButton projectId={projectId} />
        </Row>
      </div>
      <JAlerts />
      <div className={css.navigationContainer}>
        <TabNavigation />
      </div>
    </div>
  );
};
